import Cookies from 'js-cookie';
import { COOKIE_NAME_PRERENDER_DATA } from 'next/dist/server/api-utils';
import type { EventOptions, BaseEvent } from '@amplitude/analytics-types';

export const logEvent = (
  event: BaseEvent | string,
  data?: Record<string, unknown> | undefined,
  eventOptions?: EventOptions,
) => {
  /**
   * If Preview mode or SDK doesn't exist don't log amplitude events
   */
  if (Cookies.get(COOKIE_NAME_PRERENDER_DATA) || !window.amplitude) {
    return;
  }

  window.amplitude.track(event, data, eventOptions);
};

export const logB2BEvent = (event: BaseEvent | string, data?: Record<string, unknown>) => {
  logEvent(event, { ...data, user_type: 'b2b' });
};

export const setUserId = (userId?: string) => {
  /**
   * If amplitude SDK doesn't exist
   */
  if (!window.amplitude) {
    return;
  }

  window.amplitude.setUserId(userId);
};
